import { useEffect, useState } from "react";
import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import Select from 'react-select'
import { useDispatch, useSelector } from "react-redux";
import { roundedStyleSelect, styleSelect } from "../../constants/customStyles";
import { getAllCustomer } from "../../actions/CustomerActions";
import { getAllVehicle } from "../../actions/VehicleActions";
import { getAllInsuranceCompany } from "../../actions/InsuranceCompanyActions";
import Toast from "../../components/Toast";
import { getEstimateById, saveEstimate, updateEstimate } from "../../actions/EstimateActions";
import { useNavigate, useParams } from "react-router-dom";
import { getInvestigationById } from "../../actions/InvestigationActions";
import { getAllProductCategory } from "../../actions/ProductCategoryActions";
import { getAllProduct } from "../../actions/ProductActions";
import moment from "moment/moment";
import { getAllAccidentType, saveAccidentType } from "../../actions/AccidentTypeActions";
import CreatableSelect from 'react-select/creatable';
import Mobilemenu from "../../layouts/mobile-menu";

function EditEstimate() {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const params = useParams();

    useEffect(() => {
            dispatch(getEstimateById(params.estimate_id))
            dispatch(getAllVehicle(null, ''));
            dispatch(getAllCustomer(null, ''));
            dispatch(getAllInsuranceCompany(null, ''));
            dispatch(getAllProductCategory(null, ''));
            dispatch(getAllProduct(null, ''));
            dispatch(getAllAccidentType(null, ''));
         }, []);

    const estimate = useSelector(state => state?.estimate?.estimate);
    const productCategories = useSelector(state => state?.productCategory?.productCategories?.data);
    const products = useSelector(state => state?.product?.products?.data);
    const customers = useSelector(state => state?.customer?.customers?.data);
    const vehicles = useSelector(state => state?.vehicle?.vehicles?.data);
    const insuranceCompanies = useSelector(state => state?.insuranceCompany?.insuranceCompanies?.data);
    const investigation = useSelector(state => state?.investigation?.investigation);
    const accidentTypes = useSelector(state => state?.accidentTypes?.accidentTypes?.data);

    // 'investigation', estimate)

    const TypeOptions = [
        { label: 'Private', value: '1' },
        { label: 'Insurance', value: '2' },
        { label: 'N/A', value: '3' }
    ]

    const [estimateDate, setEstimateDate] = useState('');
    const [amount, setAmount] = useState('');
    const [repairTime, setRepairTime] = useState('');
    const [milage, setMilage] = useState('');
    const [accidentType, setAccidentType] = useState('');
    const [typeId, setTypeId] = useState('');
    const [contractorId, setContractorId] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState('');
    const [vehicleId, setVehicleId] = useState('');
    const [selectedVehicle, setSelectedVehicle] = useState('');
    const [lumpSum, setLumpSum] = useState(0);
    const [investigationId, setInvestigationId] = useState(estimate.investigation_id ? estimate.investigation_id : null);
    const [productCategory, setProductCategory] = useState('');
    const [product, setProduct] = useState('');
    const [investigationDetails, setInvestigationDetails] = useState({});
    const [estimateDetails, setEstimateDetails] = useState([]);
    // 'investigationId', estimate);

    // useEffect(() => {
    //     if (Object.keys(estimate).length > 0) {
    //         setEstimateDetails(estimate.detail);
    //     }
    // }, [estimate])

    // useEffect(() => {
    //     if (Object.keys(investigation).length > 0) {
    //         setInvestigationDetails(investigation);
    //     }
    // }, [investigation])

    // useEffect(() => {
    //     if (investigationId) {
    //         dispatch(getInvestigationById(investigationId));
    //     }
    // }, [investigationId])

    useEffect(() => {
        if (Object.keys(estimate).length > 0) {
            // 'estimate', estimate)
            setEstimateDate(moment(estimate?.estimate_date).format('YYYY-MM-DD'));
            setAmount(estimate?.total_amount);
            setAccidentType(estimate?.accident_type);
            setCustomerId(estimate?.customer_id);
            setSelectedCustomer(estimate?.customer?.name);
            setVehicleId(estimate?.vehicle_id);
            setSelectedVehicle(estimate?.vehicle?.plate_number);
            setRepairTime(estimate?.repair_time);
            setMilage(estimate?.milage);
            setTypeId(estimate?.type_id);
            setContractorId(estimate?.insurance_company_id);
            setTypeId(estimate?.type_id);
            setEstimateDetails(estimate.detail);
        }
    }, [estimate])

    const save = () => {
        if (estimateDate.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Estimate Date is Required!'
            })
        } else if (repairTime.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Repair Time is Required!'
            })
        } else if (milage.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Milage is Required!'
            })
        } else if (accidentType.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Accident Side is Required!'
            })
        } else if (typeId.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Type is Required!'
            })
        } else if (contractorId.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Contractor is Required!'
            })
        } else if (customerId.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Customer is Required!'
            })
        } else if (vehicleId.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle is Required!'
            })
        } else {
            let data = {
                estimate_date: estimateDate,
                amount: amount,
                repair_time: repairTime,
                milage: milage,
                accident_type: accidentType,
                lump_sum: lumpSum,
                type_id: typeId,
                insurance_company_id: contractorId,
                customer_id: customerId,
                vehicle_id: vehicleId,
                detail: estimateDetails,
                investigation_id: estimate?.investigation_id,
            }
            dispatch(updateEstimate(data, params?.estimate_id, navigate));
        }
        // window.location.href = ('/state');
    }

    const minusQuantity = async (index) => {
        let investigation = estimate;
        let quantity = parseInt(investigation.detail[index].quantity) - 1;
        // investigation)
        if (quantity > 0) {
            investigation.detail[index].quantity = (parseInt(investigation.detail[index].quantity) - 1).toString();
            investigation.detail[index].total_amount = Number(parseInt(quantity) * investigation.detail[index].sale_price).toFixed(2);
            setInvestigationDetails({ ...investigation });
        }
    }

    const addQuantity = async (index) => {
        let investigation = estimate;
        let quantity = parseInt(investigation.detail[index].quantity) + 1;
        investigation.detail[index].quantity = quantity.toString();
        investigation.detail[index].total_amount = Number(parseInt(quantity) * investigation.detail[index].sale_price).toFixed(2);
        setInvestigationDetails({ ...investigation });
    }

    const deleteItem = (e, item, index) => {
        // 'item', item);
        let items = estimate.detail;
        items.splice(items.indexOf(item), 1);
        // items.slice(0, index);
        let investigation = estimate;
        investigation.detail = items;
        
        setInvestigationDetails({ ...investigation });
        // if (items.length > 0) {
        // } else {
        // }
    }
    const onClickItem = (selectedItem) => {
        let selectedItemNew = {
            estimate_id: estimate.estimate_id,
            product_id: parseInt(selectedItem.id),
            product_name: selectedItem.name,
            quantity: 1,
            sale_price: selectedItem.list_price,
            total_amount: selectedItem.list_price,
        }
        // 'selectedItem', selectedItem)
        // selectedItem.quantity = 1;
        let found = false;
        let foundIndex = null;
        let estimateDetail = estimateDetails;
        if (estimateDetail && Object.keys(estimateDetail).length > 0) {
            estimateDetail = [...estimateDetails, selectedItemNew];
        } else {
            estimateDetail = [selectedItemNew];
        }
        setEstimateDetails([...estimateDetail]);
        // 'estimate', estimate)
    }
    

    const [isLoading, setIsLoading] = useState(false);
    // const [options, setOptions] = useState(defaultOptions);
    const [value, setValue] = useState();

    const handleCreateAccidentType = (inputValue) => {
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveAccidentType(data));
            dispatch(getAllAccidentType(null, 9999));
        }, 1000);
        const newOption = {
            id: 'new', // Unique identifier for the new option
            name: inputValue, // The name of the new option
        };
        setAccidentType(inputValue);
    }
    return (
        <span>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    <div className="d-flex align-items-center mt-8">
                        <h2 className="intro-y px-5 fs-lg fw-medium me-auto">
                            Edit Estimate
                        </h2>
                    </div>
                    <div className="intro-y box ">
                        <div className="px-5 mt-5 py-5">
                            <div className="grid columns-12 gap-4 gap-y-3 mt-3">
                                <div className="intro-y g-col-12 g-col-sm-4">
                                    <label for="date" className="form-label">Date :</label>
                                    <div className="input-group mx-auto ">
                                        <div id="input-group-email" className="input-group-text form-control-rounded"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-calendar w-4 h-4"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> </div> <input type="date" id="date" value={moment(estimate?.estimate_date).format('YYYY-MM-DD')} onChange={(e) => setEstimateDate(e.target.value)} name="date" className="datepicker form-control form-control-rounded" data-single-mode="true" />
                                    </div>
                                </div>
                                {/* <div className="intro-y g-col-12 g-col-sm-4">
                                <label for="value" className="form-label">Value :</label>
                                <input id="value" value={amount} onChange={(e) => setAmount(e.target.value)} name="value" type="text" className="form-control form-control-rounded" placeholder="Enter Value" />
                            </div> */}
                                <div className="intro-y g-col-12 g-col-sm-4">
                                    <label for="repair_time" className="form-label">Repair Time :</label>
                                    <input id="repair_time" value={repairTime} onChange={(e) => setRepairTime(e.target.value)} name="repair_time" type="text" className="form-control form-control-rounded" placeholder="Enter Repair Time" />
                                </div>
                                <div className="intro-y g-col-12 g-col-sm-4">
                                    <label for="milage" className="form-label">Mileage :</label>
                                    <input id="milage" value={milage} name="milage" onChange={(e) => setMilage(e.target.value)} type="text" className="form-control form-control-rounded" placeholder="Enter Milage" />
                                </div>
                                <div className="intro-y g-col-12 g-col-sm-4">
                                    <label for="accident_side" className="form-label">Accident Side :</label>
                                    {/* <input id="accident_side" value={estimate?.accident_type} onChange={(e) => setAccidentType(e.target.value)} name="accident_side" type="text" className="form-control form-control-rounded" placeholder="Enter Accident Side" /> */}
                                    <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                        isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateAccidentType} value={estimate?.accident_type ? { id: accidentTypes?.id, name: accidentType } : null} onChange={(e) => setAccidentType(e.name)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.id}`} options={accidentTypes && accidentTypes.length > 0 ? accidentTypes : []} styles={roundedStyleSelect} placeholder="Select Accident Type" />
                                </div>
                                <div className="intro-y g-col-12 g-col-sm-2 d-flex flex-column justify-items-center">
                                    <label for="lump_sum" className="form-label">Lump Sum :</label>
                                    <div className="mt-2">
                                        <div className="form-check form-switch"> <input onChange={(e) => setLumpSum(e.target.checked ? 1 : 0)} id="checkbox-switch-7" className="form-check-input" type="checkbox" /></div>
                                    </div>
                                </div>
                            </div>
                            <div className="grid columns-12 gap-4 gap-y-3 mt-3">
                                <div className="intro-y g-col-12 g-col-sm-3 z-10">
                                    <label for="type" className="form-label">Type :</label>
                                    {/* <Select getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.vehicle_type_id}`} options={vehicleTypes.length > 0 ? vehicleTypes : []} /> */}
                                    <Select value={estimate?.type_id ? TypeOptions.find(option => option?.value == estimate?.type_id) : null} onChange={(e) => setTypeId(e.value)} options={TypeOptions} styles={roundedStyleSelect} placeholder="Select Type" />
                                </div>
                                <div className="intro-y g-col-12 g-col-sm-3 z-10">
                                    <label for="contractor" className="form-label">Contractor :</label>
                                    <Select value={estimate?.insurance_company_id ? { id: estimate?.insurance_company_id, name: estimate?.insurance_company?.name } : null} onChange={(e) => setContractorId(e.insurance_company_id)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.insurance_company_id}`} options={insuranceCompanies && insuranceCompanies.length > 0 ? insuranceCompanies : []} styles={roundedStyleSelect} placeholder="Select Contractor" />
                                </div>
                                <div className="intro-y g-col-12 g-col-sm-3">
                                    <label for="customer" className="form-label">Customer :</label>
                                    <div className="d-flex flex-column">
                                        {
                                            estimate?.customer_id ?
                                                <Select isDisabled value={estimate?.customer_id ? { value: estimate?.customer_id, label: estimate?.customer?.name } : null} styles={roundedStyleSelect} placeholder="Select Customer" />
                                                :
                                                <Select onChange={(e) => setCustomerId(e.customer_id)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.customer_id}`} options={customers && customers.length > 0 ? customers : []} styles={roundedStyleSelect} placeholder="Select Customer" />
                                        }
                                        {/* <div className="text-center mt-2"> <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#customer-modal" className="btn btn-primary">New Customer</a> </div> */}
                                    </div>
                                </div>
                                <div className="intro-y g-col-12 g-col-sm-3">
                                    <label for="vehicle" className="form-label">Vehicle :</label>
                                    <div className="d-flex flex-column">
                                        {
                                            estimate?.vehicle_id ?
                                                <Select isDisabled value={estimate?.vehicle_id ? { value: estimate?.vehicle_id, label: estimate?.vehicle?.plate_number } : null} styles={roundedStyleSelect} placeholder="Select Vehicle" />
                                                :
                                                <Select onChange={(e) => setVehicleId(e.vehicle_id)} getOptionLabel={(option) => `${option.plate_number}`} getOptionValue={(option) => `${option.vehicle_id}`} options={vehicles && vehicles.length > 0 ? vehicles : []} styles={roundedStyleSelect} placeholder="Select Vehicle" />
                                        }
                                        {/* <div className="text-center mt-2"> <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#vehicle-modal" className="btn btn-primary">New Vehicle</a> </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="intro-y box g-col-12 border border-gray-600 mt-4 p-3">
                        <div className="grid columns-12 align-items-center">
                            <div className="g-col-12 g-col-sm-6">
                                <label for="crud-form-1" className="form-label fw-medium">Product Category</label>
                                <Select styles={roundedStyleSelect} onChange={(e) => setProductCategory(e.id)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.id}`} options={productCategories && productCategories.length > 0 ? productCategories : []} />
                            </div>
                            <div className="g-col-12 g-col-sm-5">
                                <label for="crud-form-1" className="form-label fw-medium">Product</label>
                                <Select styles={roundedStyleSelect} onChange={(e) => setProduct(e)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.id}`} options={products && products.length > 0 ? products : []} />
                            </div>
                            <div className="g-col-12 g-col-sm-1 d-flex justify-content-center align-items-end h-full">
                                <button className="btn btn-success px-5" onClick={() => onClickItem(product)}>Add</button>
                            </div>
                        </div>
                        <table class="table table-striped border-top border-gray-600 mt-4">
                            <thead>
                                <tr>
                                </tr>
                                <tr>
                                    <th className="text-nowrap">S. No</th>
                                    <th className="text-nowrap">Parts</th>
                                    <th className="text-nowrap">Price</th>
                                    <th className="text-nowrap ps-10">Quantity</th>
                                    <th className="text-nowrap">Total</th>
                                    <th className="text-nowrap">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    estimateDetails && Object.keys(estimateDetails).length > 0 &&
                                    estimateDetails.map((detail, index) => {
                                        return (
                                            <tr>
                                                <td>{index + 1}</td>
                                                <td>{detail?.product_name}</td>
                                                <td>{detail?.sale_price}</td>
                                                {/* <td><button className="btn btn-primary py-0 px-2" onClick={() => minusQuantity(index)}>-</button> {detail?.quantity} &nbsp; <button onClick={() => addQuantity(index)} className="btn btn-primary py-0 px-2">+</button> </td> */}
                                                <td><div class="input-group w-24">
                                                    <div class="input-group-text cursor-pointer fw-medium" onClick={() => minusQuantity(index)}>-</div>
                                                    <input type="text" class="form-control" value={detail?.quantity} placeholder="Quantity" />
                                                    <div onClick={() => addQuantity(index)} class="input-group-text cursor-pointer fw-medium">+</div>
                                                </div></td>
                                                <td>{detail?.total_amount}</td>
                                                <td className="">
                                                    {/* <a className="d-flex align-items-center me-5" href=""> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-edit me-1 w-6 h-6"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg> Edit </a> */}
                                                    <button className="d-flex align-items-center bg-transparent text-theme-6" onClick={(e) => deleteItem(e, detail, index)}> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-trash-2 me-1 w-6 h-6"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg> Delete </button>
                                                    {/* <a className="d-flex align-items-center text-theme-6" href="javascript:;" data-bs-toggle="modal" data-bs-target="#delete-confirmation-modal"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-trash-2 me-1 w-6 h-6"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg> Delete </a> */}
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="intro-y g-col-12 d-flex align-items-center justify-content-center justify-content-sm-end mt-5">
                        <button onClick={() => navigate('/estimates')} className="btn btn-outline-secondary bg-white w-24 ms-2">Cancel</button>
                        <button onClick={save} className="btn btn-primary w-24 ms-2">Submit</button>
                    </div>

                    <div id="delete-confirmation-modal" className="modal fade" tabindex="-1" aria-hidden="true">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-body p-0">
                                    <div className="p-5 text-center">
                                        <i data-feather="x-circle" className="w-16 h-16 text-theme-6 mx-auto mt-3"></i>
                                        <div className="fs-3xl mt-5">Are you sure?</div>
                                        <div className="text-gray-600 mt-2">
                                            Do you really want to delete these records?
                                            <br />
                                            This process cannot be undone.
                                        </div>
                                    </div>
                                    <div className="px-5 pb-8 text-center">
                                        <button type="button" data-bs-dismiss="modal" className="btn btn-outline-secondary w-24 me-1">Cancel</button>
                                        <button type="button" className="btn btn-danger w-24">Delete</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div >
            </div >
        </span>
    )
}

export default EditEstimate;